import React, { ReactElement } from 'react';
import { AppointmentSlotStyle } from './calendar.styled';

export default React.memo((): ReactElement => {
  return <AppointmentSlotStyle type="button" slotType={'DISABLED'} />;
});
